import { Model } from '@/app/shared/models/model';
import { WebhookEventStatus } from '@/app/shared/enums';

export class WebhookEventModel extends Model {
  public Attempts!: WebhookEventAttemptModel;
  public EventType!: string;
  public Status!: WebhookEventStatus;
  public ResultStatusCode?: number;
  public ResultErrorMessage?: string;
  public Created?: Date | string;
  public Data?: string;
  public Url!: string;

  constructor() {
    super();
  }
}

export class WebhookEventResendModel extends Model {
  public EventType!: string;
  public ReferenceId!: string;

  constructor() {
    super();
  }
}

export class WebhookEventAttemptModel {
  public CurrentAttempt!: number;
  public MaxAttempts!: number;
}
